import { createContext } from 'react';

export interface AuthContextData {
  email: string | null;
  accessToken: string | null;
  refreshToken: string | null;
  groupName: string | null;
}

export interface AuthContextType {
  data: AuthContextData;
  login: (email: string, accessToken: string, refreshToken: string, groupName: string) => void;
  logout: () => void;
  checkAuth: () => boolean;
}

export const AuthContext = createContext<AuthContextType | undefined>(undefined);
